interface ChevronIconProps {
  width: number;
  height: number;
  direction?: "up" | "down";
}

export const ChevronIcon = ({
  width,
  height,
  direction = "down",
}: ChevronIconProps) => {
  // Centered paths within viewBox for consistent vertical alignment
  const path = direction === "up" ? "M1 4.5l4-3 4 3" : "M1 1.5l4 3 4-3";

  return (
    <span className="sustain-badge-chevron" aria-hidden="true">
      <svg
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 10 6"
        style={{
          width: `${width}px`,
          height: `${height}px`,
        }}
      >
        <path
          d={path}
          stroke="currentColor"
          strokeWidth="1.6"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};
